(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('PortalRole', PortalRole);

    PortalRole.$inject = ['$resource'];

    function PortalRole ($resource) {
        var resourceUrl =  'api/portal-roles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
